/* eslint-disable max-len */
/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import IcomoonReact from 'icomoon-react';
import iconSet from '../../../shared/images/teambuildr-selection.json';
import { TransitionGlobal } from '../../../shared/GlobalStyles';
import CreateNewExerciseForm from '../components/presentational/CreateNewExerciseForm';
import Text from '../../../shared/components/Text/Text';

const ModalContainer = styled('div')`
    .remove-div {
      width: 100%;
      display: flex;
      justify-content: space-between;
      background: white;
      z-index: 1001;
      .remove-div-icon {
        cursor: pointer;
        transition: ${TransitionGlobal};
        :hover {
          opacity: 0.7;
        }
      }
    }
  height: 100%;
  position: relative;
`;

const ModalTextTop = styled('div')`
  font-family: 'Nunito Sans';
  font-size: 24px;
  font-weight: 700;
  margin-bottom: ${(props) => !props.disabledEditModal && '12px'};
   @media (max-width: 370px) {
    font-size: 22px;
  }
`;

const ViewOnlyWarning = styled('div')`
  display: flex;
  gap: 8px;
  border: 2px solid red;
  border-radius: 4px;
  align-items: center;
  padding: 3px;
  margin-bottom: 11px;
`;

const ModalTextTopContainer = styled('div')`
display: flex;
flex-direction: column;
`;

const CreateNewComponentModal = ({
  closeModal,
}) => {
  const modalData = useSelector((state) => state.calendar.data.modalData);
  return (
    <ModalContainer>
      <div className='remove-div'>
        <div style={{
          display: 'flex',
          alignItems: 'center',
        }}
        >
          <ModalTextTopContainer>
            <ModalTextTop disabledEditModal={modalData?.disabledEditModal}>
              {modalData?.disabledEditModal ? (
                'About Item'
              ) : (
                'Create New Exercise'
              )}
            </ModalTextTop>
            {modalData?.disabledEditModal && (
              <ViewOnlyWarning>
                <IcomoonReact
                  iconSet={iconSet}
                  size={24}
                  icon='warning'
                  color='#e8ad09ea'
                />
                <Text>This item is saved to the exercise database, to make changes view the exercise in your exercise database.</Text>
              </ViewOnlyWarning>
            )}
          </ModalTextTopContainer>
        </div>
        <div
          className='remove-div-icon'
          onClick={() => closeModal()}
        >
          <IcomoonReact
            iconSet={iconSet}
            size={15}
            icon='remove'
            color='grey'
          />
        </div>
      </div>
      <CreateNewExerciseForm
        closeModal={closeModal}
      />
    </ModalContainer>
  );
};

CreateNewComponentModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
};

export default CreateNewComponentModal;
